import * as ConsentService from "@/services/consent/consent.service";

import EventDataLayer, { SubscriberCallback } from "../../queue/EventDataLayer";
import { getBazaarvoiceFeatureUsed } from "./mappers/BazaarvoiceFeatureUsed";
import { getBazaarvoiceImpression } from "./mappers/BazaarvoiceImpression";
import { getBazaarvoicePageView } from "./mappers/BazaarvoicePageView";
import { getBazaarvoiceTransaction } from "./mappers/BazaarvoiceTransaction";

let enabled = false;

const BazaarvoiceConsent = async () => {
    enabled = await ConsentService.isPerformanceCookiesEnabled();

    window.BV?.cookieConsent.setConsent({
        bv_metrics: enabled,
        BVBRANDID: enabled,
        BVBRANDSID: enabled
    });
};

const BazaarvoiceSubscriber = (
    eventDataLayer: EventDataLayer,
    withHistory = false
) => {
    eventDataLayer.subscribe("bazaarvoice-subscriber", subscribe, withHistory);
};

const subscribe: SubscriberCallback = (event, data): void => {
    if (!enabled) return;
    if (!window.BV?.pixel) return;

    const tracker = window.BV.pixel;

    switch (event) {
        case "use-feature": {
            const featureUsedData = getBazaarvoiceFeatureUsed(data);
            if (featureUsedData) tracker.trackEvent("Feature", featureUsedData);
            break;
        }
        case "review-impression": {
            const impressionData = getBazaarvoiceImpression(data);
            if (impressionData) tracker.trackImpression(impressionData);
            break;
        }
        case "product-detail-impression": {
            const pageViewData = getBazaarvoicePageView(data);
            if (pageViewData) tracker.trackPageView(pageViewData);
            break;
        }
        case "tool-laststep": {
            const transactionData = getBazaarvoiceTransaction(data);
            if (transactionData) tracker.trackTransaction(transactionData);
            break;
        }
    }
};

export { BazaarvoiceConsent, BazaarvoiceSubscriber };
